import React from 'react';
import BasicLink from '../BasicLink';

if (process.browser) require('./Pagination.scss');

const PageLink = ({
  page, currentPage, query, ...props
}) => (
  <BasicLink
    to={{ pathname: '/', query: { query, page } }}
    className={currentPage === page ? 'current' : ''}
    data-name="pagination-link"
    {...props}
  >
    <span>{page}</span>
  </BasicLink>
);

export default function Pagination({
  total,
  itemsPerPage,
  maxPages,
  className,
  track,
  ...props,
}) {
  const count = Math.ceil(total / itemsPerPage);
  const pageCount = Math.min(count, maxPages);
  const trackDetails = { ...track, action: 'Pagination' };

  const pageLinks = Array
    .from(Array(pageCount).keys())
    .map(page => (
      <PageLink
        key={page}
        page={page + 1}
        track={trackDetails}
        {...props}
      />
    ));

  return (
    <div className={`pagination button-group-actions ${className}`}>
      <div className="button-group">{pageLinks}</div>
    </div>);
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/Pagination/Pagination.js